import cookie from 'js-cookie'

import { IUserData } from 'meta/auth'
import { ApiEndpoint } from 'controller/endpoint'
import { AuthParams, LoginParams } from 'store/auth/slice/types'
import { CookieName } from 'utils/cookie'
import { HttpRequest } from 'utils/http'

export const fetchUserData = async (params: AuthParams): Promise<LoginParams> => {
  const { token } = params

  const { data } = await HttpRequest.get<IUserData>(ApiEndpoint.users.profile(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  cookie.remove(CookieName.FAST_CHECKOUT_OBJECT)
  cookie.remove(CookieName.FAST_CHECKOUT_OTP_TOKEN)
  cookie.remove(CookieName.LAST_TRANSACTION)

  const userData = {
    ...data,
  }

  return { token: token, userData: userData }
}
